/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_Step3Inputs */

const en_gc_resources_guide_formulas_step3 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In B2, enter =IF(A2>100,"Review","OK"). A2 contains 120, so B2 should show Review.`)
};

const zh_gc_resources_guide_formulas_step3 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 B2 输入 =IF(A2>100,"Review","OK")。A2 为 120，因此 B2 应显示 Review。`)
};

/**
* | output |
* | --- |
* | "In B2, enter =IF(A2>100,\"Review\",\"OK\"). A2 contains 120, so B2 should show Review." |
*
* @param {Gc_Resources_Guide_Formulas_Step3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_step3 = /** @type {((inputs?: Gc_Resources_Guide_Formulas_Step3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_Step3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_step3(inputs)
	return zh_gc_resources_guide_formulas_step3(inputs)
});
export { gc_resources_guide_formulas_step3 as "gc.resources.guide.formulas.step3" }